import { Component, OnInit, Input, Injector } from '@angular/core';
import { KindBoard } from 'src/utils/enums';
import { InputOrder } from '../inputmodels/inputorder.models';
import { InputItem } from '../../inputcommon/inputcommon.class';
import { PageBase } from 'src/app/shared/library/page.base';

@Component({
    selector: 'cp-input-value-order',
    templateUrl: './inputvalueorder.component.html',
    styleUrls: ['./inputvalueorder.component.css'],
    standalone: false
})
export class InputValueOrderComponent extends PageBase implements OnInit {

  @Input() inputQuantityOrder: InputOrder = new InputOrder();
  @Input() isHideLoading: boolean;
  Kind = KindBoard.Insumo;
  inputItem: InputItem = new InputItem();

  constructor(public objInjector: Injector)
  {
    super(objInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.inputQuantityOrder.id = 0;
    this.inputQuantityOrder.orderValue = 0;
    this.inputQuantityOrder.orderDeliveredValue = 0;
    this.inputQuantityOrder.percentageDeliveredUnderValue = 0;
  }

  onReceiveLiterals(): void {}
}
